<template>
	<div class="snowflake__wrapper">
		<div :key="i" v-for="i in snowArray" class="snowflake" :style="snowStyle"></div>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";

export default defineComponent({
	setup() {
		const snowCount = ref<number>(100);

		const createSnowArr = (): number[] => {
			const snowArray: number[] = [];
			for (let i = 0; i < snowCount.value; i++) {
				snowArray.push(i);
			}
			return snowArray;
		};

		const snowArray = computed<number[]>(() => createSnowArr());
		const randomSnowStyle = (num: number) => Math.floor(Math.random() * num);

		const snowStyle = {
			"--left": `${randomSnowStyle(100)}vw`,
			"--left-ini": `${randomSnowStyle(5) - 10}vw`,
			"--left-end": `${randomSnowStyle(10) - 10}vw`,
			"--speed": `${1 + randomSnowStyle(5)}s`,
			"--size": `8px`,
			"--delay": `-${randomSnowStyle(5)}s`,
		};

		return {
			snowCount,
			createSnowArr,
			randomSnowStyle,
			snowStyle,
			snowArray,
		};
	},
});
</script>

<style lang="scss">
@use "sass:math";
.snowflake {
	width: var(--size);
	height: var(--size);
	background-color: #c7d8f0;
	border-radius: 50%;
	position: absolute;
	top: -2vh;
	left: var(--left);
	animation: snowfall var(--speed) linear infinite;
	animation-delay: var(--delay);
}

@keyframes snowfall {
	0% {
		transform: translate3d(var(--left-ini), 0, 0);
	}
	100% {
		transform: translate3d(var(--left-end), 110vh, 0);
	}
}
//
@for $i from 1 through 100 {
	.snowflake:nth-child(#{$i}) {
		--size: 8px;
		--left-ini: #{math.random(5) - 10}vw; /* random initial translation */
		--left-end: #{math.random(10) - 10}vw; /* math.random final translation */
		left: #{math.random(100)}vw;
		animation: snowfall #{5 + math.random(5)}s linear infinite;
		animation-delay: -#{math.random(5)}s;
	}
}

//@for $i from 1 through 100 {
//  .snowflake:nth-child(#{$i}) {
//    --size: 8px;
//    left: #{random(100)}vw;
//    animation: snowfall #{5 + random(5)}s linear infinite;
//  }
//}
</style>
